<div class="modal-content page-wrapper">
  <div class="modal-header">
    <div class="modal-title">
      <h2>File Preview</h2>
    </div>
    <a class="close" (click)="cancelDialog(null)">&times;</a>
  </div>
  <div class="modal-body">
    <div class="loader" *ngIf="loadingFile"></div>
    <img
      *ngIf="dialogParams?.type !== 'pdf' && !loadingFile"
      [src]="uploadedFile"
      onerror="this.src='assets/images/file-icons/file-pdf-1.svg'"
    />
    <embed
      *ngIf="dialogParams?.type === 'pdf' && !loadingFile"
      [attr.src]="uploadedFile"
      type="application/pdf"
      width="100%"
      height="100%"
    />
  </div>
</div>
